module.exports = __webpack_public_path__ + "img/xls.6dd59d61.svg";